import { cn } from "@/lib/utils";

export function Label({ className, ...props }: React.ComponentProps<"label">) {
  return <label className={cn("rounded-md border border-gray-300 bg-white px-3 py-2 text-sm dark:border-white/20 dark:bg-[#12161d] dark:text-white", className)} {...props} />;
}
